import { Routes } from '@angular/router';
import { permissionGuard } from '@abp/ng.core';

import { AppLayoutComponent } from './layout/layout.component';
import { NotFoundComponent } from './components/notfound/notfound.component';
import { PublicComponent } from './components/public/public.component';
import { AdvancedSearchComponent } from './components/other/advanced-search/advanced-search.component';
import { AuthGuard } from './shared/guards/auth.guard';

export const ROUTES: Routes = [
  {
    path: '',
    component: AppLayoutComponent,
    children: [
      {
        path: '',
        canActivate: [AuthGuard, permissionGuard],
        loadChildren: () => import('./components/home/home.routes').then((m) => m.HOME_ROUTES),
      },
      {
        path: 'matter',
        canActivate: [AuthGuard, permissionGuard],
        loadChildren: () => import('./components/matter/matter.routes').then((m) => m.MATTER_ROUTES),
        data: {
          requiredPolicy: 'GCM.Matter',
        },
      },
      {
        path: 'tasks',
        canActivate: [AuthGuard, permissionGuard],
        loadChildren: () => import('./components/tasks/tasks.routes').then((m) => m.TASKS_ROUTES),
        data: {
          requiredPolicy: 'GCM.EmployerTask',
        },
      },
      {
        path: 'company',
        canActivate: [AuthGuard, permissionGuard],
        loadChildren: () => import('./components/company/company.routes').then((m) => m.COMPANY_ROUTES),
        data: {
          requiredPolicy: 'GCM.Company',
        },
      },
      {
        path: 'foreign-national',
        canActivate: [AuthGuard, permissionGuard],
        loadChildren: () => import('./components/foreign-nationals/fn.routes').then((m) => m.FN_ROUTES),
        data: {
          requiredPolicy: 'GCM.ForeignNational',
        },
      },
      {
        path: 'admin',
        canActivate: [AuthGuard, permissionGuard],
        loadChildren: () => import('./components/admin/admin.routes').then((m) => m.ADMIN_ROUTES),
        data: {
          requiredPolicy: 'AbpIdentity.Users.Create',
        },
      },
      {
        path: 'report',
        canActivate: [AuthGuard, permissionGuard],
        loadChildren: () => import('./components/report/report.routes').then((m) => m.ADMIN_ROUTES),
        data: {
          requiredPolicy: 'GCM.Report',
        },
      },
      {
        path: 'ad-hoc-reports',
        canActivate: [AuthGuard, permissionGuard],
        loadChildren: () => import('./components/ad-hoc-reports/ad-hoc-reports.routes').then((m) => m.AD_HOC_REPORTS_ROUTES),
        data: {
          requiredPolicy: 'GCM.AdHocReport',
        },
      },
      {
        path: 'reminder',
        canActivate: [AuthGuard, permissionGuard],
        loadChildren: () => import('./components/reminder/reminder.routes').then((m) => m.ADMIN_ROUTES),
        data: {
          requiredPolicy: 'GCM.Reminder',
        },
      },
      {
        path: 'portal-action-tasks',
        canActivate: [AuthGuard, permissionGuard],
        loadChildren: () => import('./components/portal-action-tasks/routing/portal-action-tasks.routes').then((m) => m.PORTAL_ACTION_TASKS_ROUTES),
        data: {
          requiredPolicy: 'GCM.PortalActionTasks',
        },
      },
      {
        path: 'portal-task',
        redirectTo: 'portal-action-tasks',
        pathMatch: 'full',
      },
      {
        path: 'advanced-search',
        component: AdvancedSearchComponent,
      }
    ],
  },
  {
    path: 'public',
    component: PublicComponent,
    data: { isPublic: true },
    children: [{ path: '', loadChildren: () => import('./components/public/public.routes').then((m) => m.PUBLIC_ROUTES) }],
  },
  { path: 'notfound', component: NotFoundComponent },
  { path: '**', redirectTo: '/notfound' },
];
